var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-cotainer"},[_c('navbar'),_c('div',{staticClass:"container flex"},[_c('sidebar',{staticClass:"sidebar-container"}),_c('app-main',{staticClass:"flex-1"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }